/**
 * Formats a value for CSV output
 *
 * If the value is undefined or null, it is converted to an empty string
 * If the value is an object, it is converted to a JSON string
 * If the value is a string and contains a comma or quotation, it is wrapped in quotes
 */
export const formatValueForCSV = (value: any): string => {
  let formattedValue = value;

  if (typeof formattedValue === "undefined" || formattedValue === null) {
    return "";
  }

  if (typeof formattedValue === "object") {
    return JSON.stringify(formattedValue);
  }

  if (typeof formattedValue === "string") {
    // If the string contains a comma or a quotation, escape quotes then wrap the string in quotes
    if (formattedValue.includes(",") || formattedValue.includes('"')) {
      formattedValue = formattedValue.replace(/"/g, '""');
      formattedValue = `"${formattedValue}"`;
    }
  }

  return `${formattedValue}`;
};
